<header class="dialog-header">
  <div class="preview" [style.--tenant-color]="color()">
    <span class="preview-icon"><mat-icon>{{ icon() }}</mat-icon></span>

    <div>
      <h2>{{ name.trim() || ((data.tenant ? 'companies.tenant_edit' : 'companies.tenant_add') | translate) }}</h2>
      <span class="preview-company">{{ data.company.name }}</span>
    </div>
  </div>

  <lib-button color="none" textColor="muted" icon="close" [ariaLabel]="'form.cancel' | translate" (click)="close()"></lib-button>
</header>

<mat-dialog-content class="content">
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>{{ 'companies.name' | translate }}</mat-label>
    <input matInput [(ngModel)]="name" maxlength="60" required cdkFocusInitial />
  </mat-form-field>

  <section>
    <h3>{{ 'companies.tenant_icon' | translate }}</h3>

    <div class="icon-grid" role="radiogroup" [attr.aria-label]="'companies.tenant_icon' | translate">
      @for (item of icons; track item) {
        <button type="button" class="icon-option" role="radio" [attr.aria-checked]="item === icon()" [attr.aria-label]="item"
          [class.selected]="item === icon()" [style.--tenant-color]="color()" (click)="icon.set(item)">
          <mat-icon>{{ item }}</mat-icon>
        </button>
      }
    </div>
  </section>

  <section>
    <h3>{{ 'companies.tenant_color' | translate }}</h3>

    <div class="color-grid" role="radiogroup" [attr.aria-label]="'companies.tenant_color' | translate">
      @for (item of colors; track item) {
        <button type="button" class="color-option" role="radio" [attr.aria-checked]="item === color()" [attr.aria-label]="item"
          [class.selected]="item === color()" [style.background]="item" (click)="color.set(item)">
          @if (item === color()) { <mat-icon>check</mat-icon> }
        </button>
      }
    </div>
  </section>

  <section>
    <div class="projects-header">
      <h3>{{ 'companies.projects' | translate }} <span class="count">{{ projects().length }}</span></h3>

      @if (!data.company.allProjects && !allSelected()) {
        <lib-button color="none" textColor="primary" size="small" icon="done_all" [text]="'companies.select_all' | translate"
          (click)="selectAll()">
        </lib-button>
      }
    </div>

    <app-member-search placeholder="companies.add_project" [search]="searchProjects" [excludeIds]="projectIds()" (picked)="add($event)">
    </app-member-search>

    <div class="chips">
      @for (project of projects(); track project.id) {
        <span class="chip">
          {{ project.name }}
          <button type="button" [attr.aria-label]="('companies.detach' | translate) + ' ' + project.name" (click)="remove(project.id)">
            <mat-icon>close</mat-icon>
          </button>
        </span>
      } @empty {
        <span class="no-project">{{ 'companies.tenant_no_projects' | translate }}</span>
      }
    </div>
  </section>

  @if (error()) {
    <div class="save-error" role="alert">
      <mat-icon>error</mat-icon>
      <span>{{ error() | translate }}</span>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="actions">
  <lib-button color="none" textColor="muted" [text]="'form.cancel' | translate" (click)="close()"></lib-button>

  <lib-button icon="check" [text]="(data.tenant ? 'form.save' : 'companies.create') | translate" [loading]="saving()"
    [disabled]="saving() || !name.trim()" (click)="save()">
  </lib-button>
</mat-dialog-actions>
